import React from "react";

const FakeInput = () => {
  return (
    <React.Fragment>
      <input
        id="username"
        style={{ display: "none" }}
        type="text"
        autoFocus="autofocus"
        name="fakeusernameremembered"
      />
      <input
        id="password"
        style={{ display: "none" }}
        type="password"
        autoFocus="autofocus"
        name="fakepasswordremembered"
      />
    </React.Fragment>
  );
};
export default FakeInput;